/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../../google/type/date_pb.js')

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.reportpb = require('./reportbalance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ReportBalanceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.ReportBalanceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListReportBalanceRequest,
 *   !proto.reportpb.ListBalanceSummaryReportResponse>}
 */
const methodDescriptor_ReportBalanceService_ListBalanceSummaryReport = new grpc.web.MethodDescriptor(
  '/reportpb.ReportBalanceService/ListBalanceSummaryReport',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListReportBalanceRequest,
  proto.reportpb.ListBalanceSummaryReportResponse,
  /**
   * @param {!proto.reportpb.ListReportBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceSummaryReportResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListReportBalanceRequest,
 *   !proto.reportpb.ListBalanceSummaryReportResponse>}
 */
const methodInfo_ReportBalanceService_ListBalanceSummaryReport = new grpc.web.AbstractClientBase.MethodInfo(
  proto.reportpb.ListBalanceSummaryReportResponse,
  /**
   * @param {!proto.reportpb.ListReportBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceSummaryReportResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListReportBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListBalanceSummaryReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListBalanceSummaryReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.ReportBalanceServiceClient.prototype.listBalanceSummaryReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.ReportBalanceService/ListBalanceSummaryReport',
      request,
      metadata || {},
      methodDescriptor_ReportBalanceService_ListBalanceSummaryReport,
      callback);
};


/**
 * @param {!proto.reportpb.ListReportBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListBalanceSummaryReportResponse>}
 *     A native promise that resolves to the response
 */
proto.reportpb.ReportBalanceServicePromiseClient.prototype.listBalanceSummaryReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.ReportBalanceService/ListBalanceSummaryReport',
      request,
      metadata || {},
      methodDescriptor_ReportBalanceService_ListBalanceSummaryReport);
};


module.exports = proto.reportpb;

